var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dg-dim-layer",style:(_vm.isOpen?'display:block':'display:none'),on:{"click":function($event){return _vm.onClickBackground(false)}}},[_c('div',{staticClass:"dg-dimBg"})])}
var staticRenderFns = []

export { render, staticRenderFns }